module.exports = __webpack_public_path__ + "img/game_h-slot_pc_1.49646603.jpg";